export const generateCssClassYes = (branding: any) => {
  if (document.querySelector('.accept-btn')) {
    return true
  }
  const styleSheet = document.createElement('style')
  styleSheet.type = 'text/css'
  styleSheet.id = 'accept-btn'

  const style = `.accept-btn { color: ${branding?.modals.textColor} !important;background-color: ${branding?.modals.backgroundColor} !important; }`
  styleSheet.appendChild(document.createTextNode(style))

  document.head.appendChild(styleSheet)
  console.log(document.head)
  return 'p-button-rounded accept-btn'
}

export const generateCssClassNo = (branding: any) => {
  if (document.querySelector('.reject-btn')) {
    return true
  }
  const styleSheet = document.createElement('style')
  styleSheet.type = 'text/css'
  styleSheet.id = 'reject-btn'

  const style = `.reject-btn { color: ${branding?.modals.backgroundColor} !important;border: 1px solid ${branding?.modals.backgroundColor} !important; }`
  styleSheet.appendChild(document.createTextNode(style))

  document.head.appendChild(styleSheet)
  console.log(document.head)
  return 'p-button-rounded reject-btn'
}
